import {avatarFetchers} from '@contentlab/api/avatars';
import {CONTENT_LAB, VOICES} from '@/hooks/content-studio/consts';
import useReactQuery from '@/hooks/use-react-query';

export const useVoicesQuery = () => {
  return useReactQuery({
    queryKey: [CONTENT_LAB, VOICES],
    queryFn: avatarFetchers.getVoices,
  });
};

export default useVoicesQuery;
